import { LegalDocument } from '@/components/legal/LegalDocument';
import { TERMS_SECTIONS, TERMS_TITLE, TERMS_DATE, TERMS_TAGLINE } from '@/legal/terms';

export default function Terms() {
  return <LegalDocument title={TERMS_TITLE} subtitle={TERMS_DATE} tagline={TERMS_TAGLINE} sections={TERMS_SECTIONS} testId="terms-page" />;
}
